export default __webpack_public_path__ + "static/media/Medizen.ea99ea00.jpg";